import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { componentDefinitions, frameworkRelationship } from '../data/siteContent';
import { fadeUp } from '../utils/motion';
const models = [{
  ...componentDefinitions.cji,
  linkLabel: 'Explore CJI'
}, {
  ...componentDefinitions.ncji,
  linkLabel: 'Explore NCJI'
}];
export function HumanCapabilityModels() {
  return <section id="cji-ncji" aria-labelledby="cji-ncji-title" className="scroll-mt-20 bg-white border-t border-line py-20 lg:py-24" data-id="element-1167" data-mp="1nmpgnnzjj8v9">
      <motion.div {...fadeUp} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-1168" data-mp="1rlya0rqo54qa">
        <div className="lg:col-span-5" data-id="element-1169" data-mp="21m8oefofwi71">
          <h2 id="cji-ncji-title" className="font-heading font-bold text-3xl lg:text-4xl text-ink-dark tracking-tight leading-tight mb-5" data-id="element-1170" data-mp="21l70vbq8m38f">
            CJI and NCJI
          </h2>
          <p className="text-lg text-ink-muted leading-relaxed" data-id="element-1171" data-mp="77xvnw4q53vz">{frameworkRelationship}</p>
          <p className="mt-4 text-ink-muted leading-relaxed" data-id="element-1172" data-mp="3f1wuxsnwaia1">
            Both are methods and models under development, not finished or validated instruments.
          </p>
        </div>
        <ul className="lg:col-span-7 grid grid-cols-1 md:grid-cols-2 gap-x-10 border-t border-line" data-id="element-1173" data-mp="35blnvx8wzsyx">
          {models.map(model => <li key={model.id} className="flex flex-col pt-6 pb-2" data-id="element-1174" data-mp="317e1w7tucr4e">
              <h3 className="font-heading font-bold text-2xl text-ink-dark" data-id="element-1175" data-mp="1tk36nicmnrc">{model.shortName}</h3>
              <p className="text-sm font-medium text-teal mb-3" data-id="element-1176" data-mp="3t0wmb82slb9w">{model.name}</p>
              <p className="text-lg text-ink-dark leading-relaxed mb-5" data-id="element-1177" data-mp="3oxqcjqgh11yo">{model.definition}</p>
              <a href={model.href} className="mt-auto inline-flex items-center gap-2 font-semibold text-navy hover:text-navy-light transition-colors duration-150 whitespace-nowrap rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal" data-id="element-1178" data-mp="3jynb0fzp9dvg">
                {model.linkLabel}
                <ArrowRight size={16} aria-hidden="true" data-id="element-1179" data-mp="2f1binoul4euj" />
              </a>
            </li>)}
        </ul>
      </motion.div>
    </section>;
}